import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 14\" id=\"icon-back\">\r\n<style type=\"text/css\">\r\n\t#icon-back .st0{fill:'';}\r\n</style>\r\n<g id=\"icon-back_Frame\">\r\n\t<path id=\"icon-back_Vector\" class=\"st0\" d=\"M12.4,2H4.1V0L0,2.7l4.1,2.7V3.4h8.3c2.5,0,4.3,1.8,4.3,4.6c0,2.8-1.8,4.6-4.3,4.6H7.4\r\n\t\tc-0.3,0-0.7,0.4-0.7,0.7S7.1,14,7.4,14h4.9c3.1,0,5.6-2.4,5.6-6C18,4.3,15.5,2,12.4,2z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol